import { AuthData } from '../entities/auth/auth-data.model';
import { UserRole } from '../entities/auth/endpoint.model';
import { AuthTokens } from '../entities/auth/tokens.model';

export const areTokensDataStored = (tokens: AuthTokens) =>
  tokens.accessToken && tokens.idToken && tokens.refreshToken;

export const isAuthDataStored = (data: AuthData) =>
  data.user && data.endpoints && data.currentEndpoint && areTokensDataStored(data.tokens);

export const extractPermissionNames = (roles: UserRole[]): string[] =>
  roles.flatMap((role) => role.permissions.map((permission) => permission.name));
